import PropTypes from 'prop-types';
import { Modal } from '@material-ui/core';
import React from 'react';
import { colors } from '../../../../colorVars';
import TextButton from '../../../atomic/buttons/textButton/TextButton';
import { Body1, Body3 } from '../../../atomic/text/Text';
import style from './TradierLoginModal.module.css';
import { observer } from 'mobx-react-lite';
import { useWebsocketStore } from '../../../../stores/websocketStore/websocketProvider';

export const TradierLoginModal = observer(({ open, handleClose, page }) => {
  const { applicationTypeStore } = useWebsocketStore();
  const isSecondaryApplication =
    applicationTypeStore.isSecondaryApplication ?? null;

  if (isSecondaryApplication && page === 'ALERTS')
    return (
      <Modal open={open} onClose={handleClose} onBackdropClick={handleClose}>
        <div className={style.outerDiv}>
          <Body1 color={colors.lightGrey} fontWeight={700}>
            Tradier Brokerage Account Login Required
          </Body1>
          <div className={style.text}>
            <Body3 color={colors.lightGrey} fontWeight={500}>
              In order to use this application, please connect your Tradier brokerage account.
            </Body3>
            <Body3 color={colors.lightGrey} fontWeight={500}>
              This can be done from your main Trade Unafraid interface using the fingerprint icon. 
            </Body3>
          </div>
          <div className={style.buttons}>
            <TextButton
              width="35%"
              fontSize="medium"
              clickHandler={handleClose}
            >
              Ok
            </TextButton>
          </div>
        </div>
      </Modal>
    );
  return (
    <Modal open={open} onClose={handleClose} onBackdropClick={handleClose}>
      <div className={style.outerDiv}>
        <Body1 color={colors.lightGrey} fontWeight={700}>
          Tradier Brokerage Account Login Required
        </Body1>
        <div className={style.text}>
          <Body3 color={colors.lightGrey} fontWeight={500}>
            Please click the button below to login to your Tradier account.
          </Body3>
          <Body3 color={colors.lightGrey} fontWeight={500}>
            You will be directed to another page where you can enter your
            credentials.
          </Body3>
          <Body3 color={colors.lightGrey} fontWeight={500}>
            This will give you access to market data necessary to use this
            application.
          </Body3>
        </div>
        <div className={style.buttons}>
          <TextButton
            width="35%"
            fontSize="medium"
            clickHandler={() =>
              window.open(
                (window.config && window.config.REACT_APP_REDIRECT
                  ? window.config.REACT_APP_REDIRECT
                  : 'http://localhost:8080/') + 'loginApp',
                '_blank'
              )
            }
          >
            Login
          </TextButton>
          <TextButton
            width="35%"
            fontSize="medium"
            clickHandler={handleClose}
            backgroundColor={colors.red}
          >
            Cancel
          </TextButton>
        </div>
      </div>
    </Modal>
  );
});

TradierLoginModal.propTypes = {
  handleClose: PropTypes.func,
  open: PropTypes.bool,
};
